import { CartContext } from "@repo/contexts/CartContext";
import { logout } from "@repo/server-actions/account";
import { signOut as nextAuthSignOut } from "next-auth/react";
import { useLocale } from "next-intl";
import { usePathname, useSearchParams } from "next/navigation";
import { useContext, useEffect } from "react";

export default function useLogout({ isUnauthorized }) {
  const { setCartTotalsInfo } = useContext(CartContext);
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentUrl = pathname.includes(`/account`)
    ? `/${locale}/login`
    : pathname.includes(`/cart`)
      ? `/${locale}`
      : `${pathname}${
          searchParams.toString() ? `?${searchParams.toString()}` : ""
        }`;

  useEffect(() => {
    const handleSignOut = async () => {
      if (isUnauthorized) {
        console.error("Unauthorized Signing out");
        try {
          await logout(locale);
          setCartTotalsInfo(null);
          await nextAuthSignOut({ redirectTo: currentUrl });
        } catch (error) {
          console.error("Signout error:", error);
        }
      }
    };

    handleSignOut();
  }, [isUnauthorized, setCartTotalsInfo, locale, currentUrl]);
}
